<template>
    <div class="mobile-number">
        <div class="number-component">
            <div class="select-code">
    
                <v-select @blur="blur" v-model="countryCode" :items="code" label="Code" hide-details dense outlined></v-select>
    
            </div>
    
            <div class="add-number">
    
                <v-text-field @focus="focus" @keydown.space.prevent :maxlength="max" @keypress="isNumber($event)" @blur="blur" v-model="number" label="Mobile Number" hide-details dense outlined></v-text-field>
    
            </div>
    
        </div>
    
    </div>
</template>

<script>
export default {
    name: 'phoneNumber',
    props: ['phone', 'code', 'blur','presetPhone','focus'],
    data() {
        return {
            max:10,
            number: this.presetPhone?this.presetPhone.number:'',
            countryCode:this.presetPhone?this.presetPhone.countryCode:'+91'
        }
    },
    mounted()
    {
           
    },
    watch: {
        countryCode(val) {
            this.$emit('input', { countryCode: val, number: this.number })
        },
        number(val) {
                       this.$emit('input', { countryCode: this.countryCode, number: val })
        },
        presetPhone(val)
        {
            this.number=val.number;
            this.countryCode=val.countryCode;
        },
    },
    methods: {
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();;
            } else {
                return true;
            }
        }
    },   
  
}
</script>

